import { useTranslations } from 'next-intl';

interface ErrorMsgProps {
	msg: any;
}

export const ErrorMsg = ({ msg } :ErrorMsgProps) => {
	const t = useTranslations('General');

	return (
		<div className="survey-form__error-msg">
			<span className="survey-form__icon-error"></span>
			<span>{t(msg)}</span>
		</div>
	)
}